import React from 'react'

const InvoiceDetails = (props) => {
  const { preview } = props.info
  return <div dangerouslySetInnerHTML={{ __html: preview }} />
}

export default InvoiceDetails
